module.exports = __webpack_public_path__ + "img/card_landing.8341588d.png";